export default {
  title: 'Informații despre afacere',
  form: {},
  buttons: {
    save: 'Salvează',
  },
  toasts: {
    success: 'Informațiile au fost salvate cu succes.',
  },
};
